/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HospitalizationGetPrintLightPdf$Json$Params {

/**
 * filter criteria
 */
  hospitalizationId?: number;

/**
 * filter criteria
 */
  languageCode?: string;

/**
 * filter criteria
 */
  messageId?: number;
}

export function hospitalizationGetPrintLightPdf$Json(http: HttpClient, rootUrl: string, params?: HospitalizationGetPrintLightPdf$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
  const rb = new RequestBuilder(rootUrl, hospitalizationGetPrintLightPdf$Json.PATH, 'get');
  if (params) {
    rb.query('hospitalizationId', params.hospitalizationId, {});
    rb.query('languageCode', params.languageCode, {});
    rb.query('messageId', params.messageId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<File>;
    })
  );
}

hospitalizationGetPrintLightPdf$Json.PATH = '/v1/Hospitalization/GetPrintLightPDF';
